import { ThemeProvider } from './theme/Theme.tsx';
import { Toaster } from 'react-hot-toast';
import Main from './main/Main.tsx';
import { Purchases } from '@revenuecat/purchases-capacitor';
import { useEffect } from 'react';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';

// Wait for the device to be ready before configuring RevenueCat
document.addEventListener('deviceready', () => {
  (async () => {
    try {
      await Purchases.configure({
        apiKey: 'appl_CfhFTsozviVZbHeMGMnAVCBPWil',
      });
      console.log('[RevenueCat] Purchases configured');
    } catch (err) {
      console.error('[RevenueCat] Failed to configure Purchases:', err);
    }
  })();
});

function App() {
  useEffect(() => {
    const init = async () => {
      if (Capacitor.isNativePlatform()) {
        await new Promise((r) => setTimeout(r, 300));
        await SplashScreen.hide();
      }
    };
    init();
  });

  return (
    <ThemeProvider>
      <Main />
      <Toaster position="top-center" />
    </ThemeProvider>
  );
}

export default App;
